const hostRegex = /.*\.smartcomp\.app/;
const getApiUrl = () => {
	const lsu = localStorage.getItem("mb-api-url");
	if (lsu) return lsu.replace(/\/+$/, "");

	if (process.env.NODE_ENV === "production") {
		const match = window.location.host.match(hostRegex);
		if (match) {
			return `https://${match[0]}/api/v1`;
		}
		return "https://v4.smartcomp.app/api/v1";
	}

	return "http://localhost:3001/api/v1";
};

const API_URL = getApiUrl();

const PRESIDENTIAL =
	process.env.REACT_APP_PRESIDENTIAL === "true" ||
	process.env.REACT_APP_PRESIDENTIAL === "TRUE" ||
	window.location.host.includes("presidential");

const CAUCUS =
	process.env.REACT_APP_CAUCUS === "true" ||
	process.env.REACT_APP_CAUCUS === "TRUE" ||
	window.location.host.includes("caucus");

const CANDIDATE_TYPES = [
	{
		value: "candidate",
		label: "Candidate"
	},
	{
		value: "pac",
		label: "PAC"
	}
];

const numYears = 10 + (new Date().getFullYear() - 2021);
const CYCLES = Array(numYears)
	.fill(2021)
	.map((v, i) => String(v + i));

const BANDS = ["AM", "FM"];
const PERMISSIONS = ["Admin", "Editor"];

const MONTHS = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];

const RACE_TYPES = [
	{
		value: "primary",
		label: "Primary"
	},
	{
		value: "general",
		label: "General"
	}
];

const MEDIA_TYPES = [
	{
		value: "tv",
		label: "TV"
	},
	{
		value: "cable",
		label: "Cable"
	},
	{
		value: "radio",
		label: "Radio"
	},
	{
		value: "d2",
		label: "D2"
	},
	{
		value: "ncc_go",
		label: "NCC Go!"
	},
	{
		value: "statenet",
		label: "Statenet"
	},
	{
		value: "ncc_digital",
		label: "NCC Digital"
	},
	{
		value: "hometown_sports",
		label: "Home Team Sports"
	},
	{
		value: "ott",
		label: "OTT"
	},
	{
		value: "vod",
		label: "VOD"
	},
	{
		value: "spanish",
		label: "Spanish"
	},
	{
		value: "cable_addressable",
		label: "Cable Addressable"
	}
];

export {
	API_URL,
	CANDIDATE_TYPES,
	CYCLES,
	BANDS,
	PERMISSIONS,
	PRESIDENTIAL,
	CAUCUS,
	MONTHS,
	RACE_TYPES,
	MEDIA_TYPES
};
